import { z } from "zod";

const zIn = z.object({
  year: z.number().int().nonnegative(),
});
type In = z.infer<typeof zIn>;

const zOut = z.array(z.number().nonnegative());
type Out = z.infer<typeof zOut>;

export { zIn, zOut };
export type { In, Out };
